<div class="content">
  <Info
    title="Welk prijskaartje heeft u in gedachten voor uw aankoop?"
    details={window.zoekModalOptions.budget_text}
    imgSrc={window.zoekModalOptions.budget_image} />
  <div class="inputs">
    <span>Geef hier aan wat het budget is:</span>
    <div class="box-wrap">
      <div class="box">
        <span class="sub">Min.</span>
        <span> € </span>
        <span class="value">
          <input value={formattedValueLeft} on:keyup={minKeyup} />
        </span>
      </div>
      <svg
        width="10"
        height="1"
        viewBox="0 0 10 1"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <line y1="0.5" x2="10" y2="0.5" stroke="#202020" />
      </svg>
      <div class="box">
        <span class="sub">Max.</span>
        <span> € </span>
        <span class="value">
          <input value={formattedValueRight} on:keyup={maxKeyup} />
        </span>
      </div>
    </div>
    <div class="slider">
      <Slider
        name="1-budget"
        min={130000}
        max={2000000}
        step={25000}
        bind:valueLeft
        bind:valueRight
        on:input={({ detail }) => dispatch('complete', true)} />
    </div>
  </div>
</div>

<script>
  import Info from "./Info.svelte";
  import Slider from "./Slider.svelte";
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
  let valueLeft;
  let valueRight;

  let formattedValueLeft;
  let formattedValueRight;
  $: if (valueLeft >= 130000 && valueLeft <= 10000000)
    formattedValueLeft = valueLeft
      ? valueLeft.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      : "";
  $: if (valueRight >= 130000 && valueRight <= 10000000)
    formattedValueRight = valueRight
      ? valueRight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      : "";

  function minKeyup(args) {
    const newValue = parseFloat(args.target.value.replace(/[^0-9]/g, ""));
    valueLeft = newValue;
  }
  function maxKeyup(args) {
    const newValue = parseFloat(args.target.value.replace(/[^0-9]/g, ""));
    valueRight = newValue;
  }
</script>

<style lang="postcss">
  .content {
    @apply relative mx-5 pt-8 leading-7;
  }

  .inputs {
    @apply px-5 py-12 pt-16 border border-t-0;
  }

  .inputs > span {
    @apply inline-block w-full mb-5 text-center;
  }

  .box-wrap {
    @apply flex justify-around items-center;
  }

  .box {
    max-width: 240px;
    @apply relative w-full px-5 py-8 border flex items-center;
  }

  .sub {
    top: 12px;
    left: 20px;
    @apply absolute text-xs;
  }

  .value {
    color: #202020;
    font-weight: 500;
    @apply ml-1;
  }

  .box-wrap svg {
    @apply mx-1 flex-shrink-0;
  }

  .value {
    @apply w-full;
  }

  .value input {
    @apply w-full;
  }

  .slider {
    @apply mt-10;
  }

  @screen sm {
    .content {
      @apply mx-12;
    }

    .inputs {
      @apply p-16 mr-16;
    }

    .content :global(.details p) {
      @apply w-full pr-16;
    }

    .inputs > span {
      @apply text-left mb-10;
    }

    .box {
      @apply justify-center;
    }

    .box span {
      @apply w-auto;
    }

    .slider {
      @apply mt-16;
    }
  }

  @screen md {
    .content :global(.info) {
      @apply pb-0;
    }
    .content :global(.details p) {
      @apply w-auto px-0;
    }

    .content {
      @apply flex items-start;
    }

    .content :global(.info) {
      @apply bg-white;
    }

    .inputs {
      @apply mt-10 -ml-16 pl-32 border-t w-full mr-20;
    }

    .inputs .box-wrap,
    .inputs .slider {
      @apply max-w-2xl;
    }

    .box {
      @apply max-w-full;
    }

    .box .sub {
      position: static;
    }

    .box .sub {
      /* left: 2rem; */
    }
  }
</style>
